import React, { useState } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown as AntDropdown,
} from 'reactstrap'

import { FONTS } from '../../../constants'

export const MovementDropdown = ({
  emp,
  movementData,
  movements = [],
  isEditMovement,
  handleChangeMovement,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const movement = movements.find(m => m._id === movementData._id)
  const isActive = movement && moment(movement.start_date).isSame(emp.start_date)

  return (
    <Root>
      <InfoWrapper
        edit={ isEditMovement.toString() }
        onClick={ isEditMovement ? () => {} : () => setDropdownOpen(!dropdownOpen) }
      >
        <Title>
          { movement ? `${movement.name}${isActive ? ' (Active)' : ''}` : '-' }
        </Title>
      </InfoWrapper>
      <Dropdown
        isOpen={ dropdownOpen }
        toggle={ isEditMovement ? () => {} : () => setDropdownOpen(!dropdownOpen) }
        edit={ isEditMovement.toString() }
      >
        <DropdownToggle caret />
        <DropdownMenu>
          {movements.map((m, key) => {
            const active = moment(m.start_date).isSame(emp.start_date)
            return (
              <DropdownItem key={ key } onClick={ () => handleChangeMovement(m) }>
                <MovementItem>
                  <MovementName>{ `${m.name}${active ? ' (Active)' : ''}` }</MovementName>
                  <MovementWrapper>
                    <StartDate>Start Date</StartDate>
                    <MovementDetail>{ moment(m.start_date).format('DD/MM/YYYY') }</MovementDetail>
                  </MovementWrapper>
                </MovementItem>
              </DropdownItem>
            )
          }
          )}
        </DropdownMenu>
      </Dropdown>
    </Root>
  )
}

const Root = styled.div`
    width: 100%;
    height: 30px;
    display: flex;
    background: #F5F5F5;
    border: 1px solid #EAEAEA;
    border-radius: 4px;
    margin: 12px 0;
    position: relative;

    .dropdown {
      position: static;
    }
`

const InfoWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding: 10px 16px;
    cursor: ${p => (p.edit === 'true' ? 'default' : 'pointer')};
`

const MovementWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`

const MovementName = styled.div`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #1A1A17;
`

const StartDate = styled.div`
  font-family: ${FONTS.GOTHAM};
  font-size: 8px;
  color: #C4C4C4;
`

const MovementDetail = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: 10px;
    color: #828282;

    :nth-child(1) {
      margin-right: 8px;
    }

    :nth-child(2) {
      margin-left: 8px;
    }

`

const MovementItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const Title = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #404040;
`

const Dropdown = styled(AntDropdown)`
  width: 26px;
  height: 28px;

  :focus {
    outline: none;
  }

  .btn-secondary.dropdown-toggle {
    :active, :focus {
      background: #86A5C5;
      border: none;
    }
  }

  .dropdown-menu {
      min-width: 95%;
      transform: translate3d(-1px, 30px, 0px) !important;
  }

  .dropdown-item {
    margin: 0;

    :active {
      background: #F1F1F1;
    }

    :focus {
      outline: none;
    }
  }

  .dropdown-toggle {
    width: 100%;
    height: 100%;
    background: #86A5C5;
    border-radius: 0 4px 4px 0;
    border: none;
    opacity: ${p => (p.edit === 'true' ? 0.3 : 1)};
    cursor: ${p => (p.edit === 'true' ? 'default' : 'pointer')};
    padding: 0;
    margin: 0;

    ${p => p.edit === 'true' && `
      :focus {
        box-shadow: none;
      }
    `}

    ::after {
      margin: 0;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/new-employee/movement/movement-dropdown.js